// extracted by mini-css-extract-plugin
module.exports = {"row":"plusicon_row__N2CUd","plus-icon-side-menu":"plusicon_plus-icon-side-menu__2Xq_O","plus_icon":"plusicon_plus_icon__C-xKO","text":"plusicon_text__jgSOg"};